import { ChangesStatus } from '@editor2/types/changesStatus';
import { type MCQuestion, type MCQuestionPool } from '@editor2/types/pageElements';

export const isNew = (changesStatuses: ChangesStatus[]) => {
	return !!changesStatuses?.includes(ChangesStatus.New);
};

export const isModified = (changesStatuses: ChangesStatus[]) => {
	return !isNew(changesStatuses) && !!changesStatuses?.includes(ChangesStatus.Modified);
};

export const isNewQuestion = (initialElement: MCQuestionPool, question: MCQuestion) =>
	!initialElement?.questions.find((q) => q.family_id === question.family_id);
